import Abstract from "../../../abstract-view/abstract.js";
import {
  createElement
} from "../../../render/render.js";

const createContentTemplate = () => {
  return (
    `<div class="content content_category" style="display: none;"></div>`
  );
};

export default class Content extends Abstract {
  constructor(wrapperElement) {
    super();

    this._wrapperElement = wrapperElement;
    this._sectionElement = null;
  }

  prepareElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getSectionElement() {
    if (!this._sectionElement) {
      this._sectionElement = this._wrapperElement.parentElement.querySelector(`.section_content`);
    }

    return this._sectionElement;
  }

  getElement() {
    if (!this._element) {
      const sectionElement = this.getSectionElement();
      this._element = sectionElement.firstElementChild;
    }

    return this._element;
  }

  getContent() {
    return this._element.innerHTML.trim();
  }

  setContent(content) {
    this._element.innerHTML = content;
  }

  show() {
    this._element.style.display = null;
  }

  _getTemplate() {
    return createContentTemplate();
  }
}
